import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const getVehicles = createAsyncThunk(
  "vehicle/getVehicles",
  async (filters = {}, { rejectWithValue }) => {
    try {

      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== undefined && v !== "")
      );

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle`,
        {
          ...axiosConfig,
          params,
        }
      );

      return response.data;
    } catch (err) {
      return handleAxiosError(err, rejectWithValue);
    }
  }
);

export const getVehicleByID = createAsyncThunk(
  "vehicle/getVehicleByID",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle/${id}`,
        {
          ...axiosConfig,
        }
      );

      return response.data;
    } catch (err) {
      return handleAxiosError(err, rejectWithValue);
    }
  }
);